/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckSquareCutIcon20Regular = forwardRef('CheckSquareCutIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M3.75 6A2.25 2.25 0 0 1 6 3.75h6a.75.75 0 0 0 0-1.5H6A3.75 3.75 0 0 0 2.25 6v8A3.75 3.75 0 0 0 6 17.75h8A3.75 3.75 0 0 0 17.75 14v-3a.75.75 0 0 0-1.5 0v3A2.25 2.25 0 0 1 14 16.25H6A2.25 2.25 0 0 1 3.75 14V6Z" }),
        React.createElement("path", { d: "M17.937 5.062A.75.75 0 0 0 16.876 4l-6.708 6.708a.813.813 0 0 1-1.149 0l-2.33-2.33a.75.75 0 0 0-1.06 1.06l2.33 2.33a2.312 2.312 0 0 0 3.27 0l6.708-6.707Z" })));
});
